import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
// common components
import CustomButton from './../../common/Forms/CustomButton/CustomButton';
import Loader from './../../common/Loader/Loader';
import TakeTest from './TakeTest/TakeTest';
import CircularProgress from '@material-ui/core/CircularProgress';
// css
import './Mockexam.scss';

const Mockexam = ({ history, match, dashContext, commonContext }) => {

	const [userId, setuserId] = useState(null);
	const [userHist, setuserHist] = useState(null);
	const [moduleId, setmoduleId] = useState(null);
	const [attemptlen, setattemptlen] = useState(null);
	const [optionResult, setoptionResult] = useState([]);
	const [check, setcheck] = useState(false);
	const [ansArray, setansArray] = useState([]);
	const [ansFlag, setansFlag] = useState(false);
	const [next, setNext] = useState(false);
	const [curIndex, setCurIndex] = useState(null);
	const [totalCount, setTotalCount] = useState(null);
	const [testScore, setTestScore] = useState('');
	const [disBtn, setDisBtn] = useState(true);

	useEffect(() => {
		setTestScore('');
		commonContext.updateLoaderMsg();
	}, []);

	// on load
	useEffect(() => {
		if (history && history.location && history.location.state && history.location.state.user_id) {
			setuserId(history.location.state.user_id);
			setmoduleId(history.location.state.module_id);
			setattemptlen(history.location.state.attempt);
			// setTestScore('');
			// console.log(testScore, 'testScore');
		} else {
			history.replace('dashboard');
		}
	}, [history]);


	// on load
	useEffect(() => {
		dashContext.clearPrepare();
		dashContext.clearTestResult();
		if (userId, moduleId, attemptlen) {
			dashContext.getDashPrepare(userId, moduleId, attemptlen);
		}
	}, [userId, moduleId, attemptlen]);

	// on question updated
	useEffect(() => {
		setansFlag(false);
		setansArray([]);
		if (dashContext.question && dashContext.question.result) {
			let tempArray = [];
			for (let i = 0; i < dashContext.question.result.options.length; i++) {
				let data = {
					option_id: dashContext.question.result.options[i].id,
					correct_answer: 'N',
				}
				tempArray.push(data);
			}
			const corlen = dashContext.question.result.options.filter(item => (item.correct_answer === 'Y')).length > 1;

			setoptionResult(tempArray);
			setuserHist(dashContext.question.user_history_id);
			setcheck(corlen);
			setNext(false);
			setCurIndex(dashContext.question.curr_ques_index);
			setTotalCount(dashContext.question.total_ques_count);
		}
	}, [dashContext.question]);

	// on result updated
	useEffect(() => {
		if (dashContext.ansresult && dashContext.ansresult.length > 0) {
			let tempAns = false;
			let tempAnsArray = [];

			tempAns = dashContext.ansresult.some(item => item.correct_answer !== item.user_correct_answer);

			for (let i = 0; i < dashContext.ansresult.length; i++) {
				if (dashContext.ansresult[i].correct_answer === 'Y') {
					tempAnsArray.push(dashContext.ansresult[i].option_id);
				}
			}
			setansFlag(tempAns);
			setansArray(tempAnsArray);
			setNext(true);
		}
	}, [dashContext.ansresult]);

	// on test result
	useEffect(() => {
		// if (dashContext.testResult && dashContext.testResult !== '') {
		// 	setTestScore(dashContext.testResult);
		// }
		setTestScore(dashContext.testResult);
	}, [dashContext.testResult]);

	const onChangeOption = (option_id) => {
		let tempArray = optionResult;
		for (let i = 0; i < optionResult.length; i++) {
			if (tempArray[i].option_id == option_id) {
				tempArray[i].correct_answer = 'Y';
			} else {
				tempArray[i].correct_answer = 'N';
			}
		}
		const tempVal = tempArray.every(x => x.correct_answer === 'N');
		setDisBtn(tempVal);

		setoptionResult(tempArray);
	}

	const onToogleCheck = (val, index) => {
		const isCorrect = val ? 'Y' : 'N';
		let tempArray = optionResult;
		tempArray[index].correct_answer = isCorrect;
		const tempVal = tempArray.every(x => x.correct_answer === 'N');
		setDisBtn(tempVal);
	}

	const onQuesSubmit = () => {
		dashContext.getSubmitQues(userHist, optionResult);
		setDisBtn(true);
	}

	const onNextQues = () => {
		dashContext.getNextQues(userId, moduleId, attemptlen);
	}

	const onFinishTest = () => {
		dashContext.finishTest(userId, moduleId, attemptlen);
	}

	if (
		dashContext
		&& dashContext.question
		&& dashContext.question.show_finish === 'Y'
		&& dashContext.question.all_test_quest_complete === 'Y'
		&& dashContext.question.user_test_complete === 'N'
	) {
		return (
			<div className='Mockexam score'>
				<div className="markinfo">
					<img src="./assets/images/svg/LowMarks.svg" />
					<div className="information">
						<div>
							<div className="heading">COMPLETED!</div>
							<div className="desc">Get the score</div>
						</div>
						<div className="percentage">
							<CustomButton name='Finish' onClick={() => onFinishTest()} />
						</div>
					</div>
				</div>
			</div>
		);
	}

	if (testScore && testScore !== '') {
		const tempScore = testScore.replace(/\%/g, '');
		return (
			<div className='Mockexam score'>
				<div className="markinfo">
					{tempScore < 90 ? (
						<img src="./assets/images/svg/LowMarks.svg" />
					) : (
							<img src="./assets/images/svg/HighScore.svg" />
						)}
					<div className="information">
						<div>
							{tempScore < 90 ? (
								<div className="heading">TRY AGAIN!</div>
							) : (
									<div className="heading">CONGRATS!</div>
								)}
							<div className="desc">You have got</div>
						</div>
						<div className="percentage">
							<div className='result'>{testScore}</div>
							<CustomButton name='go to dashboard' onClick={() => history.replace('dashboard')} />
						</div>
					</div>
				</div>
			</div>
		);
	}

	if (testScore === '' && dashContext && dashContext.question && dashContext.question.result) {
		return (
			<div className='Mockexam'>
				<div className='exam-header'>
					<div className="left-header">
						<div role='presentation' className="header-logo" onClick={() => history.replace('dashboard')}>
							<img src="./assets/images/png/favicon.png" alt="leanwisdom_logo" />
						</div>
						<div className="heading">{dashContext.question.result.module_name}</div>
					</div>
					<div className='exam-actions'>
						<div className='qcounter'>{curIndex} <span>&#47;</span> {totalCount}</div>
						{next ?
							(
								<React.Fragment>
									{curIndex < totalCount ? (
										<CustomButton name='next' onClick={() => onNextQues()} />
									) : (
											<CustomButton name='finish' onClick={() => onFinishTest()} />
										)}
								</React.Fragment>
							) :
							(<CustomButton name='submit' onClick={() => onQuesSubmit()} disabled={disBtn} />)
						}
					</div>
				</div>
				<TakeTest
					question={dashContext.question.result}
					onChangeOption={onChangeOption}
					check={check}
					onToogleCheck={onToogleCheck}
					ansArray={ansArray}
					ansFlag={ansFlag}
				/>
			</div>
		);
	}
	return (<Loader text="no question found" />);
}

Mockexam.propTypes = {
	history: PropTypes.instanceOf(Object),
	match: PropTypes.instanceOf(Object),
	dashContext: PropTypes.instanceOf(Object)
};

Mockexam.defaultProps = {
	history: {},
	match: {},
	dashContext: {}
};

export default Mockexam;



// WEBPACK FOOTER //
// ./components/Mockexam/Mockexam.js